class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super()
    this.addEventListener('click', (event) => {
      event.preventDefault()
      this.closest('cart-notification').updateQuantity(this.dataset.index, 0)
      this.closest('.cart-notification-product').classList.add('loading')
      this.closest(
        '.cart-notification-product'
      ).firstElementChild.classList.remove('hidden')
    })
  }
}
customElements.define('cart-remove-button-2', CartRemoveButton2)

class CartNotification extends HTMLElement {
  constructor() {
    super()

    this.notification = this
    this.cartItemConatiner = this.querySelector('#cart-notification-product')

    this.header = document.querySelector('sticky-header')
    this.onBodyClick = this.handleBodyClick.bind(this)

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.close()
    )

    this.querySelector(
      'button[type="button"].cart-notification__close'
    ).addEventListener('click', this.close.bind(this))

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0)

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event)
    }, 300)

    this.addEventListener('change', this.debouncedOnChange.bind(this))
  }

  onChange(event) {
    if (event.target.closest('quantity-input')) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute('name'),
        event.target.dataset.quantityVariantId
      )
    }
  }

  open() {
    this.notification.classList.add('animate', 'active')
    document.querySelector('body').classList.add('added__overlay')
    document.querySelector('body').classList.add('cart-drawer-open')

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus()
        trapFocus(this.notification)
      },
      { once: true }
    )

    document.body.addEventListener('click', this.onBodyClick)
  }

  close() {
    this.notification.classList.remove('active')
    document.querySelector('body').classList.remove('added__overlay')
    document.querySelector('body').classList.remove('cart-drawer-open')
    document.body.removeEventListener('click', this.onBodyClick)

    //removeTrapFocus(document.querySelector(".header__actions_btn--cart"));
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id)
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id]
      )
    })

    if (this.header) this.header.reveal()
    this.open()
    document.dispatchEvent(new CustomEvent('cart-drawer:rendered'))
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification',
      },
      {
        id: 'cart-notification-count',
      },
    ]
  }

  updateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    })

    document
      .querySelector('.cart_action_drawer_overlay')
      .classList.add('active')
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text()
      })
      .then((state) => {
        const parsedState = JSON.parse(state)
        const quantityElement = document.getElementById(`Quantity-${line}`)
        const items = document.querySelectorAll('.cart-notification-product')

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute('value')
          this.updateLiveRegions(line, parsedState.errors)
          return
        }

        this.renderContents(parsedState)

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined
        let message = ''
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === 'undefined') {
            message = window.cartStrings.error
          } else {
            message = window.cartStrings.quantityError.replace(
              '[quantity]',
              updatedValue
            )
          }
        }
        this.updateLiveRegions(line, message)

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-notification',
          cartData: parsedState,
          variantId: variantId,
        })
      })
      .catch(() => {})
      .finally(() => {
        document
          .querySelector('.cart_action_drawer_overlay')
          .classList.remove('active')
      })
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`)
    if (lineItemError) {
      lineItemError.classList.remove('d-none')
      lineItemError.querySelector('.cart-item__error-text').innerHTML = message
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML
  }

  handleBodyClick(evt) {
    const target = evt.target
    if (
      target !== this.notification &&
      !target.closest('cart-notification') &&
      !target.closest('#quickViewWrapper')
    ) {
      this.close()
    }
  }

  setActiveElement(element) {
    this.activeElement = element
  }
}

customElements.define('cart-notification', CartNotification)

function trackCartDrawerEvent(action, location = 'cart_drawer') {
  const analyticsReady = !!(window.Shopify && window.Shopify.analytics)
  console.log(
    '[cart-drawer analytics] event fired:',
    action,
    { location, analyticsReady }
  )
  if (analyticsReady) {
    window.Shopify.analytics.publish('custom_event', { action, location })
    console.log(
      '[cart-drawer analytics] published to Shopify.analytics:',
      action
    )
  } else {
    console.warn(
      '[cart-drawer analytics] Shopify.analytics not available, event NOT published:',
      action
    )
  }
  document.dispatchEvent(
    new CustomEvent('cart-drawer:track', { detail: { action, location } })
  )
}

document.addEventListener('click', (event) => {
  const tracked = event.target.closest('[data-track-action]')
  if (!tracked) return
  trackCartDrawerEvent(
    tracked.dataset.trackAction,
    tracked.dataset.trackLocation || 'unknown'
  )
})

// SHR-102 + SHR-106: Checkout+ protection toggle.

const PROTECTION_DESC_FALLBACK = 'Unlock free returns on this order for $4.99'

function refreshCartDrawerSections() {
  const sections = 'cart-notification,cart-notification-count'
  return fetch(window.location.pathname + '?sections=' + sections)
    .then((r) => r.json())
    .then((data) => {
      const parser = new DOMParser()
      Object.keys(data).forEach((id) => {
        const el = document.getElementById(id)
        if (!el) return
        const parsed = parser.parseFromString(data[id], 'text/html')
        const content = parsed.querySelector('.shopify-section')
        if (content) el.innerHTML = content.innerHTML
      })
      document.dispatchEvent(new CustomEvent('cart-drawer:rendered'))
    })
    .catch((err) => console.warn('Cart drawer section refresh failed', err))
}

window.CartDrawerProtectionToggle = {
  variantId: null,
  price: null,
  observer: null,
  busy: false,

  init() {
    const source = document.getElementById('offset-cart-drawer-ui-offer')
    const wrapper = document.querySelector('.cart-drawer__protection-toggle')
    if (!wrapper) return

    const toggleInput = wrapper.querySelector('.cart-drawer__toggle-input')
    const priceEl = wrapper.querySelector('.cart-drawer__toggle-price')
    const descEl = wrapper.querySelector('.cart-drawer__toggle-description')
    if (!toggleInput) return

    const self = this

    const settingVariantId = wrapper.dataset.variantId
    if (settingVariantId && /^\d+$/.test(settingVariantId)) {
      self.variantId = settingVariantId
    }

    function extractOffsetData() {
      if (!source || source.children.length === 0) return

      if (!self.variantId) {
        const idSources = source.querySelectorAll(
          '[data-variant-id], [data-product-id], [data-offer-id], [data-id], ' +
            'input[name*="id"], input[name*="variant"], input[type="hidden"]'
        )
        for (const el of idSources) {
          const id =
            el.dataset.variantId ||
            el.dataset.productId ||
            el.dataset.offerId ||
            el.dataset.id ||
            el.value
          if (id && /^\d{10,}$/.test(id.trim())) {
            self.variantId = id.trim()
            break
          }
        }
      }

      const allText = source.textContent || ''
      if (!self.price) {
        const priceMatch = allText.match(/\$(\d+\.?\d{0,2})/)
        if (priceMatch) {
          self.price = parseFloat(priceMatch[1])
          if (priceEl) priceEl.textContent = '$' + priceMatch[1]
        }
      }

      if (descEl && !descEl.textContent.trim()) {
        const lower = allText.toLowerCase()
        if (lower.includes('free returns')) {
          descEl.textContent = PROTECTION_DESC_FALLBACK
        } else if (lower.includes('protection')) {
          descEl.textContent = 'Add order protection'
        }
      }

      if (self.variantId || self.price) {
        wrapper.removeAttribute('hidden')
      }
    }

    function isProtectionItem(item) {
      if (self.variantId) {
        return String(item.variant_id) === String(self.variantId)
      }
      const title = (item.title || '').toLowerCase()
      const vendor = (item.vendor || '').toLowerCase()
      const productType = (item.product_type || '').toLowerCase()
      const props = Object.values(item.properties || {})
        .join(' ')
        .toLowerCase()
      return (
        title.includes('checkout+') ||
        title.includes('offset') ||
        vendor.includes('offset') ||
        productType.includes('checkout+') ||
        props.includes('checkout+')
      )
    }

    function syncToggleState() {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const protectionItem = cart.items.find(isProtectionItem)
          if (protectionItem) {
            toggleInput.checked = true
            if (!self.variantId) {
              self.variantId = String(protectionItem.variant_id)
            }
            if (!self.price) {
              self.price = protectionItem.price / 100
              if (priceEl) priceEl.textContent = '$' + self.price.toFixed(2)
            }
            wrapper.removeAttribute('hidden')
          } else {
            toggleInput.checked = false
          }
        })
        .catch((err) => console.warn('Cart state sync failed', err))
    }

    async function addProtection() {
      if (!self.variantId) return null
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{ id: parseInt(self.variantId, 10), quantity: 1 }],
        }),
      })
      if (!res.ok) return null
      return fetch('/cart.js').then((r) => r.json())
    }

    async function removeProtection() {
      const cart = await fetch('/cart.js').then((r) => r.json())
      const protectionItem = cart.items.find(isProtectionItem)
      if (protectionItem) {
        if (!self.variantId) {
          self.variantId = String(protectionItem.variant_id)
        }
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: protectionItem.key, quantity: 0 }),
        })
        return fetch('/cart.js').then((r) => r.json())
      }
      return cart
    }

    if (!toggleInput.dataset.bound) {
      toggleInput.dataset.bound = 'true'
      toggleInput.addEventListener('change', async () => {
        if (self.busy) return
        self.busy = true
        toggleInput.disabled = true

        trackCartDrawerEvent(
          toggleInput.checked ? 'protection_opt_in' : 'protection_opt_out'
        )

        try {
          const cart = toggleInput.checked
            ? await addProtection()
            : await removeProtection()

          if (cart) {
            await refreshCartDrawerSections()
          }
        } catch (err) {
          console.warn('Protection toggle failed', err)
          toggleInput.checked = !toggleInput.checked
        } finally {
          self.busy = false
          toggleInput.disabled = false
        }
      })
    }

    if (self.variantId) {
      wrapper.removeAttribute('hidden')
      if (descEl && !descEl.textContent.trim()) {
        descEl.textContent = PROTECTION_DESC_FALLBACK
      }
      if (!wrapper.dataset.impressed) {
        wrapper.dataset.impressed = 'true'
        trackCartDrawerEvent('protection_impression')
      }
    }

    if (source) {
      if (this.observer) this.observer.disconnect()
      this.observer = new MutationObserver(() => extractOffsetData())
      this.observer.observe(source, { childList: true, subtree: true })

      if (source.children.length > 0) {
        extractOffsetData()
      }
    }

    syncToggleState()
  },
}

window.CartDrawerProtectionToggle.init()

document.addEventListener('cart-drawer:rendered', () => {
  window.CartDrawerProtectionToggle.init()
})

window.addEventListener('pageshow', (event) => {
  if (event.persisted) {
    refreshCartDrawerSections()
  }
})

class OpenMiniCart extends HTMLElement {
  constructor() {
    super()

    this.cartButton = this.querySelector('a')

    this.cartButton.addEventListener('click', (event) => {
      event.preventDefault()
      this.onClickMiniCart()
    })

    this.notification = document.getElementById('offcanvas__mini_cart')
    this.onBodyClassRemove = this.handleBodyClass.bind(this)

    this.notification.addEventListener(
      'keyup',
      (evt) => evt.code === 'Escape' && this.miniCartClose()
    )
  }

  onClickMiniCart() {
    document
      .getElementById('offcanvas__mini_cart')
      .classList.add('animate', 'active')
    document.querySelector('body').classList.add('added__overlay')
    document.querySelector('body').classList.add('cart-drawer-open')

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus()
        trapFocus(this.notification)
      },
      { once: true }
    )

    document.body.addEventListener('click', this.onBodyClassRemove)
  }

  miniCartClose() {
    document.getElementById('offcanvas__mini_cart').classList.remove('active')
    document.querySelector('body').classList.remove('added__overlay')
    document.querySelector('body').classList.remove('cart-drawer-open')

    document.body.removeEventListener('click', this.onBodyClassRemove)
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target
    if (
      !eventTarget.closest('cart-notification') &&
      !eventTarget.closest('open-minicart') &&
      !eventTarget.closest('button')
    ) {
      this.miniCartClose()
    }
  }
}
customElements.define('open-minicart', OpenMiniCart)
